import { Component, ViewEncapsulation, OnInit, Inject, ViewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import { ExcelExportData } from "@progress/kendo-angular-excel-export";
import { TablerIconsModule } from "angular-tabler-icons";
import { NgScrollbarModule } from "ngx-scrollbar";
import { CluContextItem } from "src/app/@clu-fe/apps/m-cashdesk/@models/clucontext.model";
import { ConnectorCashDeskDaoService } from "src/app/@clu-fe/apps/m-cashdesk/cashdesk/connector-cashdesk-dao.service";
import { KendoModule } from "src/app/kendo.module";
import { MaterialModule } from "src/app/material.module";
import { CustomDatePipe } from "src/app/pipe/customDate.pipe";
import { CustomPipesModule } from "src/app/pipe/customPipes.module";
import { CluAgentService } from "src/app/utils/clu-agent/clu-agent.service";

@Component({
    selector     : 'md-clu-ghostmode-fn-agent-tickets',
    templateUrl  : './md-clu-ghostmode-fn-agent-tickets.component.html',
    styleUrls: ['./md-clu-ghostmode-fn-agent-tickets.component.scss'],
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [FormsModule, MaterialModule, KendoModule, TranslateModule, TablerIconsModule, NgScrollbarModule, CustomPipesModule, CustomDatePipe],
    providers : [ConnectorCashDeskDaoService]
})
export class MdCluGhostModeFnAgentTicketsComponent implements OnInit {

    loading = false;
    errorMessage = '';
    paginatedItems: any;
    items: any[] = [];
    cluContextItem: CluContextItem;
    columns: { pName: string, title: string, pType?: string, hidden: boolean }[] = [
        { pName: 'MD_SITE', title: 'Site', hidden: false },
        { pName: 'MD_CAISSE', title: 'Caisse', hidden: false },
        { pName: 'MD_CAISSE_LIB', title: 'Caisse', hidden: false },
        { pName: 'MD_CAISSIER', title: 'Caissier', hidden: false },
        { pName: 'MD_CAISSIER_LIB', title: 'Caissier', hidden: false },
        { pName: 'MD_CAISSE_SESSION', title: 'Session', hidden: false },
        { pName: 'DO_PIECE_INTERNAL', title: 'Ticket', hidden: false },
        { pName: 'DO_DATE', title: 'Date', hidden: false },
        { pName: 'DO_TYPE_OP', title: 'Type op.', hidden: false },
        { pName: 'DO_SOUCHELIB', title: 'Souche', hidden: false },
        { pName: 'DO_TIERS', title: 'Code client', hidden: false },
        { pName: 'DO_TOTALHT', title: 'Total HT', hidden: false },
        { pName: 'DO_TOTALTTC', title: 'Total TTC', hidden: false },
        { pName: 'DO_MONTANTREGLE', title: 'Total RG', hidden: false },
        { pName: 'DO_SOLDETTC', title: 'Reste', hidden: false },
        { pName: 'NB_LIGNE', title: 'Lignes [NB]', hidden: false },
        { pName: 'DE_INTITULE', title: 'Dépôt', hidden: false },
        { pName: 'DO_REF', title: 'Référence', hidden: false },
        { pName: 'LC_CARTE_NUM', title: 'Carte Fidélité', hidden: false },
        { pName: 'LC_CLIENT_LIB', title: 'Client Fidélité', hidden: false },
        { pName: 'DO_COORD02', title: 'E/02', hidden: false },
        { pName: 'DO_COORD03', title: 'E/03', hidden: false },
        { pName: 'DO_COORD04', title: 'E/04', hidden: false },
        { pName: 'CO_LIB', title: 'Collaborateur', hidden: false },
    ];
    height = window.innerHeight - 305;
    @ViewChild('cluGrid') cluGrid: any;

    constructor(
        private matDialogRef: MatDialogRef<MdCluGhostModeFnAgentTicketsComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private cluAgentService: CluAgentService,
        private connectorCashDeskDaoService: ConnectorCashDeskDaoService
    ){
    }

    async ngOnInit() {
        this.cluContextItem = await this.connectorCashDeskDaoService.runQuery_doGetCashDeskItem()
        this.doGetListTicketsAction();
    }

    onClose() {
        this.matDialogRef.close();
    }

    async doGetListTicketsAction() {
        if (!this.cluContextItem) { return; }

        this.loading = true;
        this.errorMessage = '';

        try {
            this.paginatedItems = await this.cluAgentService.doGetListTicketsItemsAction_CashDeskSync({
                MD_CAISSE_SESSION: this.cluContextItem.DEVICE!.CAISSE_SESSION,
                PageSize: 100
            });
            this.items = this.paginatedItems.mDatas.map((i: any) => i.CLU_TICKET_ITEM.ENTETE);
            setTimeout(() => this.cluGrid.autoFitColumns(), 10);
        } catch(error: any) {
            this.errorMessage = error;
            console.log(error);
        } finally {
            this.loading = false;
        }
    }
    
    doGridFetchAllData(): ExcelExportData {
        const result: ExcelExportData =  {
            data: this.items
        };
        return result;
    }
} 